import React, { useState } from 'react';
import IssueReportList from './IssueReportList';
import IssueReportMap from './IssueReportMap';
import IssueReportButton from './IssueReportButton';
import { AlertTriangle, MapPin, BarChart3, Award } from 'lucide-react';

export default function IssueReportDashboard() {
  const [activeTab, setActiveTab] = useState('list');
  
  const issueStats = {
    totalReports: 127,
    resolvedIssues: 43,
    pendingVerification: 18,
    yourContributions: 5
  };
  
  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Environmental Issue Scanner</h2>
          <p className="text-gray-600">
            Report and track environmental issues in your community
          </p>
        </div>
        
        <IssueReportButton />
      </div>
      
      {/* Stats Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <div className="flex items-center space-x-3">
            <div className="bg-emerald-100 p-2 rounded-lg">
              <AlertTriangle className="h-5 w-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{issueStats.totalReports}</p>
              <p className="text-sm text-gray-600">Total Reports</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <div className="flex items-center space-x-3">
            <div className="bg-green-100 p-2 rounded-lg">
              <Award className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{issueStats.resolvedIssues}</p>
              <p className="text-sm text-gray-600">Resolved Issues</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <div className="flex items-center space-x-3">
            <div className="bg-yellow-100 p-2 rounded-lg">
              <BarChart3 className="h-5 w-5 text-yellow-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{issueStats.pendingVerification}</p>
              <p className="text-sm text-gray-600">Pending Verification</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <div className="flex items-center space-x-3">
            <div className="bg-blue-100 p-2 rounded-lg">
              <MapPin className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{issueStats.yourContributions}</p>
              <p className="text-sm text-gray-600">Your Contributions</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Tabs */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div className="border-b border-gray-200">
          <div className="flex">
            <button
              onClick={() => setActiveTab('list')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'list'
                  ? 'text-emerald-600 border-b-2 border-emerald-500'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              List View
            </button>
            <button
              onClick={() => setActiveTab('map')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'map'
                  ? 'text-emerald-600 border-b-2 border-emerald-500'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Map View
            </button>
          </div>
        </div>
        
        <div className="p-6">
          {activeTab === 'list' ? <IssueReportList /> : <IssueReportMap />}
        </div>
      </div>
      
      {/* Mobile Floating Action Button */}
      <div className="md:hidden">
        <IssueReportButton variant="fixed" />
      </div>
    </div>
  );
}